import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreditCardSharedComponent } from './credit-card.component';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { InputSharedModule } from '../input/input.module';

@NgModule({
    declarations: [
        CreditCardSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        InputSharedModule
    ],
    exports: [
        CreditCardSharedComponent
    ]
})

export class CreditCardSharedModule {}
